import { render, staticRenderFns } from "./CotizadorAdmin.vue?vue&type=template&id=4f380dfa&scoped=true&"
import script from "./CotizadorAdmin.vue?vue&type=script&lang=js&"
export * from "./CotizadorAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CotizadorAdmin.vue?vue&type=style&index=0&id=4f380dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f380dfa",
  null
  
)

export default component.exports